import Moment from "moment"

export const getRevisionRowCel = (sortedMinistrationsPlan = [], status) => {
  const periodColumns = {}
  sortedMinistrationsPlan.forEach(ministrationPlan => {
    periodColumns[`period${ministrationPlan.orderIndex}`] = ministrationPlan.revisionDueDate
      ? Moment(ministrationPlan.revisionDueDate).format("DD/MMMM/YYYY")
      : null
  })

  return { status, ...periodColumns }
}
